exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ModalFilter-root-NDAuZ {\n  padding: 25px;\n}\n\n.ModalFilter-cancelBtn-lWWSl {\n  display: inline-block;\n  color: var(--btn-primary-bg) !important;\n  -webkit-text-decoration: none;\n  text-decoration: none;\n  cursor: pointer;\n  margin-right: 30px;\n  font-size: 16px;\n}\n.ModalFilter-closeIcon-M5cJM{\n\theight: 30px;\n    margin-top: -11px;\n    margin-left: -1px;\n    background: var(--icon-bg-color);\n    border-radius: 20px;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    cursor: pointer;\n}\n.ModalFilter-modalTitle-Hwnze{\n\tcolor: var(--btn-primary-bg);\n  margin-top: -25px;\n}", ""]);

// exports
exports.locals = {
	"root": "ModalFilter-root-NDAuZ",
	"cancelBtn": "ModalFilter-cancelBtn-lWWSl",
	"closeIcon": "ModalFilter-closeIcon-M5cJM",
	"modalTitle": "ModalFilter-modalTitle-Hwnze"
};